import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

type ZendeskInputProps = {
  label: string
  type?: 'text' | 'email' | 'number' | 'textarea'
  value: string
  placeholder?: string
  id: string
  onChange: (value: string) => void,
  error?: string
}

const ZendeskInput = ({
  label,
  type = 'text',
  id,
  value,
  placeholder,
  error,
  onChange
}: ZendeskInputProps) => {
  return (
    <div>
      <S.Label htmlFor={id}>{label}</S.Label>
      {type === 'textarea' ? (
        <S.TextArea
          id={id}
          value={value}
          rows={6}
          onChange={(e) => onChange(e.target.value)}
          data-testid={id}
        />
      ) : (
        <S.Input
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          autoComplete={id}
          onChange={(e) => onChange(e.target.value)}
          data-testid={id}
        />
      )}
      {error && <S.ErrorText>{error}</S.ErrorText>}
    </div>
  )
}

const S = {
  Label: styled.label`
    font-weight: bold;
    display: block;
    color: ${color('primaryText')};
    margin-bottom: 6px;
  `,
  Input: styled.input`
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${color('border')};
    border-radius: 0.5rem;
    margin-bottom: 0.875rem;
    font-size: 0.875rem;
    &:focus {
      outline: none;
      border-color: ${color('primaryText')};
    }
  `,
  TextArea: styled.textarea`
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${color('border')};
    border-radius: 0.5rem;
    margin-bottom: 0.875rem;
    font-size: 0.875rem;
    resize: none; 
    &:focus {
      outline: none;
      border-color: ${color('primaryText')};
    }
  `,
  ErrorText: styled.p`
    color: ${color('errorText')};
    font-size: 0.875rem;
    margin: 4px 0 0 0;
    position: relative;
    top: -15px;
  `
}

export default ZendeskInput
